[
  {
    "code": "TT-ARI",
    "name": "Arima"
  },
  {
    "code": "TT-CHA",
    "name": "Chaguanas"
  },
  {
    "code": "TT-CTT",
    "name": "Couva-Tabaquite-Talparo"
  },
  {
    "code": "TT-DMN",
    "name": "Diego Martin"
  },
  {
    "code": "TT-PED",
    "name": "Penal-Debe"
  },
  {
    "code": "TT-PTF",
    "name": "Point Fortin"
  },
  {
    "code": "TT-POS",
    "name": "Port of Spain"
  },
  {
    "code": "TT-PRT",
    "name": "Princes Town"
  },
  {
    "code": "TT-RCM",
    "name": "Rio Claro-Mayaro"
  },
  {
    "code": "TT-SFO",
    "name": "San Fernando"
  },
  {
    "code": "TT-SJL",
    "name": "San Juan-Laventille"
  },
  {
    "code": "TT-SGE",
    "name": "Sangre Grande"
  },
  {
    "code": "TT-SIP",
    "name": "Siparia"
  },
  {
    "code": "TT-TOB",
    "name": "Tobago"
  },
  {
    "code": "TT-TUP",
    "name": "Tunapuna-Piarco"
  }
]